export const answersEmail = data => {
  const { number, path } = data;
  return `<!DOCTYPE html>
    <html
      lang="en"
      xmlns="http://www.w3.org/1999/xhtml"
      xml:lang="en"
      style="background:#CCCCCC"
    >
      <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link
          href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,700"
          rel="stylesheet"
        />
        <meta http-equiv="X-UA-Compatible" content="ie=edge" />
        <title>Document</title>
      </head>

      <body style="background:#CCCCCC; max-width: 800px;">
        <table
          style="border-spacing: 0px; font-family:'Source Sans Pro', Arial, Helvetica, sans-serif; width: 600px; max-width: 600px; background: #ffffff; margin: 0 auto;"
        >
          <thead>
          </thead>

          <tbody style="font-size: 11pt;">
            <tr>
              <td style=" padding: 16px; text-align: center;">
                <p
                  style="font-family: Arial;
                font-size: 20px;
                text-align: left;
                padding: 2rem 0;"
                >
                  Se ha registrado una incidencia en el Pedido "${number}" en la app
                  de Inspección. Para consultar la incidencia da click en el botón
                  "Consultar".
                  <br>
                  <br>
                  <span style="font-weight: 600;">Equipo Prosic.</span>
                </p>

                <a
                  href="${process.env.VUE_APP_URL}/${path}"
                  style="background-color: rgb(255, 205, 0);
                border-radius: 5px;
                color: black;
                font-size: 20px;
                padding: 10px 40px;
                text-align: center;
                text-decoration: none;
                display: inline-block;
                cursor: pointer;"
                >
                  Consultar
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </body>
    </html>`;
};
